import * as luxon from 'luxon';

/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';

import { OrdDeAllocateMultipleActions } from './ord-deallocate-multiple.actions';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: any;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: [],
    receivedTime: null,
};

export default createFeature({
  name: 'ordDeAllocateMultiple',
  reducer: createReducer(
    initialState,
    on(OrdDeAllocateMultipleActions.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(OrdDeAllocateMultipleActions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(OrdDeAllocateMultipleActions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
    })),
    on(OrdDeAllocateMultipleActions.load, (state: State): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
  )}
);
